(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["k7-store"] && !Shopify.designMode) return;
  try {
    
function initK7(root){if(root.dataset.ready)return;root.dataset.ready='true';const photo=root.querySelector('.k7-selected-image');root.querySelectorAll('.k7-thumb').forEach(button=>button.addEventListener('click',()=>{photo.src=button.dataset.image;photo.removeAttribute('srcset');photo.alt=button.dataset.alt;root.querySelectorAll('.k7-thumb').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));const choices=root.querySelectorAll('.k7-variant-card input');choices.forEach(choice=>choice.addEventListener('change',()=>{root.querySelectorAll('.k7-variant-card').forEach(card=>card.classList.toggle('is-selected',card.contains(choice)));root.querySelector('.k7-price').textContent=choice.dataset.price;const add=root.querySelector('.k7-add');add.disabled=choice.dataset.available!=='true';add.textContent=add.disabled?'غير متوفر حاليًا':'أضيفي إلى السلة';const stock=root.querySelector('.k7-stock-note');if(stock)stock.hidden=!add.disabled;if(choice.dataset.image&&photo){photo.src=choice.dataset.image;photo.removeAttribute('srcset');photo.alt=choice.dataset.alt||''}const url=new URL(location.href);url.searchParams.set('variant',choice.value);history.replaceState({},'',url)}))}
document.querySelectorAll('.k7').forEach(initK7);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.k7').forEach(initK7));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
